import { Box, SxProps, Typography } from "@mui/material";
import {
  colorLandingInk,
  colorLandingMuted,
  fontLandingDisplay,
} from "src/design/tokens";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: "center" | "left";
  sx?: SxProps;
}

/**
 * Display-face section title with an optional lede underneath. Every landing
 * section opens with one, so the type scale lives here rather than per section.
 */
export const SectionHeading = ({
  title,
  subtitle,
  align = "center",
  sx,
}: SectionHeadingProps) => (
  <Box sx={{ textAlign: align, ...sx }}>
    <Typography
      component="h2"
      sx={{
        fontFamily: fontLandingDisplay,
        fontWeight: 400,
        fontSize: { xs: 28, sm: 34, md: 44 },
        lineHeight: 1.08,
        letterSpacing: "-0.005em",
        color: colorLandingInk,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        sx={{
          mt: 2,
          fontSize: { xs: 16, md: 19 },
          lineHeight: 1.55,
          color: colorLandingMuted,
          maxWidth: "60ch",
          mx: align === "center" ? "auto" : 0,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);
